import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Select from 'react-select';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Modal, Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';

class StaffsByDesignationIndex extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.exportDesignation = this.exportDesignation.bind(this);
    this.showModal = this.showModal.bind(this);
    this.loadModal = this.loadModal.bind(this);
    this.loadData = this.loadData.bind(this);
    this.export = this.export.bind(this);
    this.expandComponent = this.expandComponent.bind(this);
    this.botaoEdicao = this.botaoEdicao.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/colaboradores/por/designacoes', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  export(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }

  exportDesignation (row) {

    if (row.staff_revisions.length > 0 && row.staff_revisions[0].status == 3) {
      var designacao = (
        <div className="col-md-2">
          <button className="btn btn-primary btn-block btn-lg" onClick={() => {this.export('/exportar/revisao/designacao/' + row.staff_revisions[0].id)}}><i className="fa fa-fw fa-file-pdf-o"></i>Designação</button>
        </div>
      )
    } else if (row.designation_file !== '') {
      var designacao = (
        <div className="col-md-2">
          <a className="btn btn-primary btn-block btn-lg" href={config.get('cdn') + "/uploads/designations/" + row.designation_file} target="_blank"><i className="fa fa-fw fa-file-pdf-o"></i>Designação</a>
        </div>
      )
    }

    return designacao;

  }

  loadModal (id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/colaborador/escalas/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_schedules_list:responseJson.data});
          self.showModal();
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  showModal (value, event) {
    this.setState({ modal: true});
  }

  botaoEdicao (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className={'btn btn-primary'}>
          <i className="fa fa-fw fa-file-pdf-o"></i> Exportações 
        </button>
      </div>
    );

    return botao;
  }
 expandComponent(row) {
    return (
      <div className="expandable-row" style={{padding: '40px'}}>
        <div className="row">
          <div className={(row.designation_file !== '' || (row.staff_revisions.length > 0 && row.staff_revisions[0].status == 3)) ? 'col-md-2' : 'col-md-2 col-md-offset-1'}>
            <Link className={'btn btn-primary btn-block btn-lg'} to={'/colaborador/' + row.id}>
              <i className="fa fa-address-card"></i> Página
            </Link>
          </div>
          {this.exportDesignation(row)}
          <div className="col-md-2">
            <button className="btn btn-primary btn-block btn-lg" onClick={() => {this.export('/exportar/identificacao/full/colaborador/' + row.id)}}><i className="fa fa-fw fa-file-pdf-o"></i> ID</button>
          </div>
          <div className="col-md-2">
            <button className="btn btn-primary btn-block btn-lg" onClick={() => {this.export('/exportar/identificacao/pasta/colaborador/' + row.id)}}><i className="fa fa-fw fa-file-pdf-o"></i> ID Pasta</button>
          </div>
          <div className="col-md-2">
            <button className="btn btn-primary btn-block btn-lg" onClick={() => {this.export('/exportar/curriculo/colaborador/' + row.id)}}><i className="fa fa-fw fa-file-pdf-o"></i> Currículo</button>
          </div>
          <div className="col-md-2">
            <button className={"btn btn-primary btn-block btn-lg"} onClick={() => this.loadModal(row.id)} >
              <i className="fa fa-fw fa-file-pdf-o"></i> Escalas
            </button>
          </div>
        </div>
      </div>
    );
  }
  
 expandableRow(row) {
    return true;
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">Lista de colaborador por designação</h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há colaborador cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar' expandComponent={ this.expandComponent } expandableRow={ this.expandableRow } >

        <TableHeaderColumn dataField="name" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome</TableHeaderColumn>

        <TableHeaderColumn dataField="inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Matrícula</TableHeaderColumn>

        <TableHeaderColumn dataField="staff_references" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Referência</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicao} width='300'>Ações</TableHeaderColumn>
      </BootstrapTable>
      <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left">Exportar escalas</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              <label>Escala a exportar:</label>
              <Select
                className="form-field-name"
                name="schedule_grade_id"
                value={this.state.schedule_grade_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'schedule_grade_id')}
                options={this.state.staff_schedules_list}
                required
              />
            </div>
            <div className="col-md-6">
              <button onClick={() => (this.export('/exportar/escala/grade/visualizar/' + this.state.schedule_grade_id))} className="btn btn-primary btn-inline btn-block"> <i className="fa fa-fw fa-file-pdf-o"></i> Exportar escala</button>
              <button onClick={() => (this.export('/exportar/escala/grade/gestao/visual/' + this.state.schedule_grade_id))} className="btn btn-primary btn-inline btn-block"> <i className="fa fa-fw fa-file-pdf-o"></i> Exportar gestão visual</button>
            </div>
          </div>  
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
  </div>
</div>
    );
  }
}


export default StaffsByDesignationIndex;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsByDesignationIndex.js